
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * React-Admin List component for: Country Resource
 */

import * as RA from 'react-admin';


const postFilters = [
    <RA.TextInput source="search" label="Search" alwaysOn />
];
const CountryList = () => (
    <RA.List filters={postFilters}> 
        <RA.Datagrid rowClick="edit">
            <RA.TextField source="alpha2" />

            <RA.TextField source="phonePrefix" />

            <RA.NumberField source="id" />

            <RA.TextField source="name" />

            
        </RA.Datagrid>
    </RA.List>
);

export default CountryList;

